import video from '../../assets/banner.mp4'

export const Home = () => {
  return <>
    <video autoPlay muted loop playsInline style={{ position: 'relative', width: '100%', height: '100%', objectFit: 'cover' }}>
      <source src={video} type="video/mp4" />
    </video>
  </>
}

export default Home